import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AuthConfigService, OAuthLibWrapperService, WindowRef } from 'haba-core';
import { OAuthService, TokenResponse } from 'angular-oauth2-oidc';
import { BaseSiteToBrandService } from 'haba-base-components';

@Injectable({ providedIn: 'root' })
export class HabaOAuthLibWrapperService extends OAuthLibWrapperService {
  constructor(
    oAuthService: OAuthService,
    authConfigService: AuthConfigService,
    @Inject(PLATFORM_ID) platformId: object,
    winRef: WindowRef,
    private baseSiteToBrand: BaseSiteToBrandService
  ) {
    super(oAuthService, authConfigService, platformId, winRef);
  }

  authorizeWithPasswordFlow(userId: string, password: string): Promise<TokenResponse> {
    let brand;
    this.baseSiteToBrand
      .currentBrand()
      .subscribe((value) => (brand = value))
      .unsubscribe();
    return this.oAuthService.fetchTokenUsingPasswordFlow(userId, password);
  }
}
